// @flow

import type {ApplicationState} from '../../types'
import type {SessionState} from '../types'

export function getError(appState: ApplicationState): ?string {
  return _getError(appState.session)
}

function _getError(state: SessionState): ?string{
  return state.error
}

getError.internal = _getError
